import React, { Component, Fragment } from 'react';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
import RiskAttributeEntry from './RiskAttributeEntry';
import Slider from '../../../../shared/slider/Slider';
import * as _ from 'lodash';
import { InfoTooltip } from '../../../../shared/info-tooltip/InfoTooltip';

class RiskFactorEntry extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attributesExpanded: false
        };
    }

    render() {
        const attributes = [];

        for (let attribute in this.props.riskFactorAttributes) {
            attributes.push({
                attribute: attribute,
                riskLevel: this.props.riskFactorAttributes[attribute]
            });
        }

        return (
            <Fragment>
                <div className="risk-factor-entry">
                    <span className="risk-factor-info">
                        {this.props.riskFactor}
                        {this.props.tooltipMessage && (
                            <InfoTooltip message={this.props.tooltipMessage} />
                        )}
                    </span>
                    <span className="risk-factor-weight">
                        <Slider
                            percentage={this.props.riskFactorWeight}
                            readOnly={this.props.readOnly}
                            updatePercentage={percentage =>
                                this.props.updateRiskFactor(percentage)
                            }
                        />
                    </span>
                    {!_.isEmpty(this.props.riskFactorAttributes) && (
                        <span className="risk-factor-action">
                            {this.state.attributesExpanded ? (
                                <ExpandLess
                                    style={{
                                        color: 'var(--darker-gray)',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() =>
                                        this.setState({
                                            attributesExpanded: false
                                        })
                                    }
                                />
                            ) : (
                                <ExpandMore
                                    style={{
                                        color: 'var(--darker-gray)',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() =>
                                        this.setState({
                                            attributesExpanded: true
                                        })
                                    }
                                />
                            )}
                        </span>
                    )}
                </div>

                {this.state.attributesExpanded && (
                    <span>
                        {attributes.map(riskFactorAttribute => (
                            <RiskAttributeEntry
                                key={riskFactorAttribute.attribute}
                                name={riskFactorAttribute.attribute}
                                riskLevel={riskFactorAttribute.riskLevel}
                            />
                        ))}
                    </span>
                )}
            </Fragment>
        );
    }
}

export default RiskFactorEntry;
